const RoomType = Object.freeze({
  Collective: 'collective',
  Group: 'group',
});

export default RoomType;
